import React from 'react';
import * as S from './DetailsLeftBlock.styles';

import BkngDetailsBlock from './BkngDetailsBlock/BkngDetailsBlock';
import BookingInfo from './BookingInfo/BookingInfo';
import TripHotelDetails from './TripHotelDetails/TripHotelDetails';
import ImportantInfo from './ImportantInfo/ImportantInfo';
import Policies from './Policies/Policies';

const DetailsLeftBlock = ({bookingDetails, hotelDetails, bookingInfo, trip_type, impInfo, policiesInfo}) => {

  return(
    <S.LeftBlockMainWrap>
      <BkngDetailsBlock bookingDetails={bookingDetails} trip_type={trip_type} />
      <BookingInfo bookingInfo={bookingInfo} />
      <TripHotelDetails hotelDetails={hotelDetails} />
      <ImportantInfo impInfo={impInfo} />
      <Policies policiesInfo={policiesInfo} />
    </S.LeftBlockMainWrap>
  );
}

export default DetailsLeftBlock;
